// extracted by mini-css-extract-plugin
export default {"joiningHearts":"joiningHearts__NzMyO","loader":"loader__MTY3M","petal":"petal__ZjgxN","spin":"spin__YzJmM"};